/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addNote } from '../fn/crm-api/add-note';
import { AddNote$Params } from '../fn/crm-api/add-note';
import { ApiResponseCrmAuthUrlResponse } from '../models/api-response-crm-auth-url-response';
import { ApiResponseCrmTokenInfo } from '../models/api-response-crm-token-info';
import { ApiResponseString } from '../models/api-response-string';
import { ApiResponseVoid } from '../models/api-response-void';
import { connect } from '../fn/crm-api/connect';
import { Connect$Params } from '../fn/crm-api/connect';
import { disconnect } from '../fn/crm-api/disconnect';
import { Disconnect$Params } from '../fn/crm-api/disconnect';
import { status } from '../fn/crm-api/status';
import { Status$Params } from '../fn/crm-api/status';

@Injectable({ providedIn: 'root' })
export class CrmApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addNote()` */
  static readonly AddNotePath = '/v1/api/ui/zoho-crm/notes/{module}/{recordId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNote$Response(params: AddNote$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return addNote(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNote(params: AddNote$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.addNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

  /** Path part for operation `connect()` */
  static readonly ConnectPath = '/v1/api/ui/zoho-crm/connect';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connect$Response(params: Connect$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmAuthUrlResponse>> {
    return connect(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connect(params: Connect$Params, context?: HttpContext): Observable<ApiResponseCrmAuthUrlResponse> {
    return this.connect$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCrmAuthUrlResponse>): ApiResponseCrmAuthUrlResponse => r.body)
    );
  }

  /** Path part for operation `status()` */
  static readonly StatusPath = '/v1/api/ui/zoho-crm/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `status()` instead.
   *
   * This method doesn't expect any request body.
   */
  status$Response(params: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmTokenInfo>> {
    return status(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `status$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  status(params: Status$Params, context?: HttpContext): Observable<ApiResponseCrmTokenInfo> {
    return this.status$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCrmTokenInfo>): ApiResponseCrmTokenInfo => r.body)
    );
  }

  /** Path part for operation `disconnect()` */
  static readonly DisconnectPath = '/v1/api/ui/zoho-crm/disconnect';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disconnect()` instead.
   *
   * This method doesn't expect any request body.
   */
  disconnect$Response(params: Disconnect$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return disconnect(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disconnect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disconnect(params: Disconnect$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.disconnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

}
